import { useParams } from "react-router";

/**
    Prior to react-router v7, useParams was not typed.
    This allowed developers to destructure any property from the params object.
    This is unsafe and should be avoided.
    This hook endeavours to provide a temporary way to access the params object,
    while all usages are updated to deal with the fact that the params may actually
    be undefined at runtime.

    @deprecated Use useParams() instead.
*/
export const useUnsafeParams = (): Record<string, string> => {
  const params = useParams();
  return params as Record<string, string>;
};
